// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { makeEntitySelector } from '../../../../../selectors/zoneSelectors';
import Zone from '../Zone';
import type { Props } from '../Zone';

type OwnProps = $ReadOnly<{|
    id: string
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    return {
        zone: makeEntitySelector(props.id)(state)
    };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(Zone);